//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/LayoutMap')
let roadOperation = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'roadOperation/allRoad',//全国道路运营热力图
        component: _import('roadOperation/allRoad/map'),
        name: 'roadOperation',
        meta: {
          title: '全国道路运营热力图',
          icon: 'widgets'
        }
      },
      {
        path: 'roadOperation/hotCities',//热门城市
        component: _import('roadOperation/hotCities/map'),
        name: 'roadOperation',
        meta: {
          title: '热门城市运营热力图',
          icon: 'widgets'
        }
      },
      {
        path: 'roadOperation/wayCity',//途径城市数据
        component: _import('roadOperation/wayCity/list'),
        name: 'roadOperation',
        meta: {
          title: '途径城市数据',
          icon: 'widgets'
        }
      }
    ]
  }
]
export default roadOperation;